import React from 'react';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

const HeaderTheme = ({ isReverse = false, isOverlay = false }) => {
  const className = classNames({
    [ `header-is-reverse` ]: isReverse,
    [ `header-is-overlay` ]: isOverlay
  });

  return (
    <Helmet bodyAttributes={{ class: className }}/>
  );
};

export default HeaderTheme;